import { Widget, mk_widget, Option, none, some } from 'widgets-for-react'
import React from 'react'

export const loader: Widget<never> = mk_widget({
  run: o => <Loader />
})

function randomColor(): string {
  const colors = ['#1D89B8', '#F39600', '#CAF0F4', '#EAD4D0', '#707C87', '#BB212D', '#DBD323']
  return colors[Math.floor(Math.random() * colors.length)]
}

class Loader extends React.Component<{}, {}> {
  private ref: Option<SVGSVGElement> = none<SVGSVGElement>()
  private interval: Option<any> = none<any>()

  constructor(props: {}) {
    super(props)
    this.updateColor = this.updateColor.bind(this)
  }

  setRef(e: SVGSVGElement) {
    if (this.ref.v.kind == 'r') return
    this.ref = some(e)
    if (this.interval.v.kind == 'r') clearInterval(this.interval.v.v)
    let tmp = setInterval(this.updateColor, 1200) as any
    this.interval = some(tmp)
  }

  componentWillUnmount() {
    if (this.interval.v.kind == 'l') return
    clearInterval(this.interval.v.v)
  }

  updateColor(args: any[]) {
    if (this.ref.v.kind == 'l') return
    this.ref.v.v.setAttribute('fill', randomColor())
    this.ref.v.v.setAttribute('fill', randomColor())
    this.ref.v.v.setAttribute('fill', randomColor())
    this.ref.v.v.setAttribute('fill', randomColor())
  }

  render() {
    return  <div className="loader loader--page">
    <div className="loader__inner">
      <svg className="loader__icon" width="60px" height="60px" aria-hidden="true">
        <use xlinkHref="#icon--loader" />
        <span className="sr-only">Loading...</span>
      </svg>
    </div>
  </div> 
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/loader.mod.tsx